import React from 'react'
import { useHostServices } from '../../HostServices'
import VehiclesLoader from './VehiclesLoader'
import { LobShell } from '../Shared'

export const Vehicles: React.FC = () => {
  const { featureFlags } = useHostServices()
  const isAutoEnabled = featureFlags.variation('FF_SPOG_WEB_UI', true)

  return isAutoEnabled ? (
    <LobShell header="Vehicles" customizeTriggerLob="auto">
      <VehiclesLoader />
    </LobShell>
  ) : null
}
